import React, {useState, useEffect, useRef} from 'react'
import { PrizeIntro } from './PrizeIntro'

export const Cars = ({content}) => {
    
    const refLeft = useRef(null)
    const refRight = useRef(null)

    const [carIndex, setCarIndex] = useState(0)

    // offset range for changing image when scrolling
    const carsOffset = [[-100, 500], [700, 1300], [1500, 2500]]

    window.onscroll = e => {
        let offset = refRight.current.getBoundingClientRect().y - refLeft.current.getBoundingClientRect().y

        for(let i=0; i<content.length; i++){
            if(offset > carsOffset[i][0] && offset < carsOffset[i][1]){
                setCarIndex(i)
            }
        }
    }

    useEffect(() => {
        // window.onscroll = (e) => {
        //     console.log(ref.current.getBoundingClientRect().y-ref2.current.getBoundingClientRect().y)
        //     // console.log(ref.current.getBoundingClientRect().y)
        //     // console.log(ref2.current.getBoundingClientRect().y)
        // }
        // console.log(ref.current.getBoundingClientRect())
    }, [])

    return (
        <div className='cars-wrapper'>
            <div className='cars-left-right'>
                <div className='cars-left' ref={refLeft}>
                    {
                        content.map((car, index) => (
                            <div className='car-info' key={index}>
                                <img src={car.logo} className='car-logo' />
                                <p className='car-year'></p>
                                <p className='car-title'>{car.title}</p>
                                <p className='car-price'>{car.price}</p>                                               
                            </div>
                        ))
                    }
                </div>
                <div className='cars-right'>
                    <div ref={refRight} className='sticky-wrapper'>
                        {
                            content.map((car, index) => (                            
                                <div className={carIndex == index? 'fix-car-img': 'hide'} key={index}>
                                    <img src={car.img} />
                                </div>
                            ))
                        }
                    </div>
                </div>            
            </div>
            <div className='cars-top-bottom'>
                {
                    content.map((car, index) => (
                        <PrizeIntro prize={car} imageRight={false} show2021={true} key={index}/>
                    ))
                }
            </div>
        </div>        
    )
}